import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e16b016a&lang=pug&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.9.1_1afa42f4f5bcd5610bd17c24e9bdc0f1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports